import ProfitLossStatement from '@features/ocr/components/DocumentTypes/ProfitLossStatement';
import STRReport from '@features/ocr/components/DocumentTypes/STRReport';
import ADRMetrics from '@features/ocr/components/DocumentTypes/ADRMetrics';
import OccupancyMetrics from '@features/ocr/components/DocumentTypes/OccupancyMetrics';
import RevPARMetrics from '@features/ocr/components/DocumentTypes/RevPARMetrics';

// Export a mapping of document type names to their components
export default {
  'Profit & Loss Statement': ProfitLossStatement,
  'STR Report': STRReport,
  'ADR Metrics': ADRMetrics,
  'Occupancy Metrics': OccupancyMetrics,
  'RevPAR Metrics': RevPARMetrics,
};